const KEY_PREFIX = "@flowls/";

export const LocalStorageKeys = {
  DATETIME_FORMAT: `${KEY_PREFIX}datetime_format`,
  TIMEZONE: `${KEY_PREFIX}timezone`,
  ZOOM_LEVEL: `${KEY_PREFIX}zoomLevel`,
};
